import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Row,
  Col,
  Container,
  CardBody,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import MaeketPriceTable from "components/table/marketPriceTable";
import {
  LIVE_PRICE_COLUMNS_TETHER,
  LIVE_PRICE_COLUMNS_TOMAN,
} from "constants/tableColumns";
import { selectpriceTokens } from "store/selector/bestPriceCoins";
import { getTokensItem } from "utils/getters";
import { selectToken } from "store/selector/tokenStore";
import { logoOptions } from "constants/lotties";
import LottieLogo from "components/pages/lottie";
import cn from "classnames";
import "assets/styles/components/navbar.scss";
import "assets/styles/components/card.scss";
import "assets/styles/components/variantProperty.scss";

export default function BestPriceTable() {
  const { t }: { t: any } = useTranslation();
  const [activeTab, setActiveTab] = useState("toman-tab");
  const toggleTab = (tab: string) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const tomanColumns = LIVE_PRICE_COLUMNS_TOMAN;
  const tetherColumns = LIVE_PRICE_COLUMNS_TETHER;
  const defaultOptions = logoOptions;

  const stateList = useSelector(selectpriceTokens);
  const { allTokens } = useSelector(selectToken);
  const { tokenList } = stateList;
  const TetherMarket: any = getTokensItem("USDT");
  const TomanMarket: any = getTokensItem("TMN");

  return (
    <Container className="mt-n7 ">
      <div className="mt-n12 mt-md-0">
        <Row className="mb-n1 ">
          <Col xs={{ order: 2 }} sm="12">
            <div className="style-nav-tab nav ">
              <Nav
                tabs
                className="border-radius-tl-1 border-radius-tr-1  none-border-bottom py-2 nav--width none-padding"
              >
                <div className="d-flex align-items-center  justify-content-around mt-2 w-100">
                  <span className="d-flex align-items-center table-font-mobile text-secondary-one-light text-nowrap">
                    {t("select:")}
                  </span>
                  <div className="d-flex box box-md box-md-gray py-1 px-1 mx-3  nav-Item-mx">
                    <NavItem
                      className={activeTab === "toman-tab" ? "nav-active" : ""}
                    >
                      <NavLink
                        className={cn(
                          "fw-Medium px-3 text-secondary-three-light nav-link--padding bg-gray table-font-mobile ",
                          {
                            active: activeTab === "toman-tab",
                          }
                        )}
                        onClick={() => {
                          toggleTab("toman-tab");
                        }}
                      >
                        {t("Toman Markets")}
                      </NavLink>
                    </NavItem>
                    <NavItem
                      className={activeTab === "tether-tab" ? "nav-active" : ""}
                    >
                      <NavLink
                        className={cn(
                          "fw-Medium px-3 table-font-mobile text-secondary-three-light  nav-link--padding bg-gray",
                          {
                            active: activeTab === "tether-tab",
                          }
                        )}
                        onClick={() => {
                          toggleTab("tether-tab");
                        }}
                      >
                        {t("Tether Markets")}
                      </NavLink>
                    </NavItem>
                  </div>
                </div>
              </Nav>
            </div>
          </Col>
        </Row>
        <Card className="shadow none-padding  border-radius-tl-1 border-radius-br-1 border-radius-bl-1">
          <CardBody className="fs-6 none-padding ">
            {allTokens.length && tokenList.length ? (
              <>
                <Row>
                  <Col xs={{ order: 1 }} sm="12">
                    <TabContent activeTab={activeTab}>
                      <TabPane tabId="toman-tab">
                        <Row>
                          <Col sm="12">
                            <MaeketPriceTable
                              columns={tomanColumns}
                              data={TomanMarket}
                            />
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="tether-tab">
                        <Row>
                          <Col sm="12">
                            <MaeketPriceTable
                              columns={tetherColumns}
                              data={TetherMarket}
                            />
                          </Col>
                        </Row>
                      </TabPane>
                    </TabContent>
                    <div className="d-flex align-items-center justify-content-center pb-4">
                      <Link
                        to={"/show-all-markets"}
                        className=" text-warning-light"
                      >
                        {t("See all currencies")}
                      </Link>
                      <i className="icon-arrow-circle-left px-1" />
                    </div>
                  </Col>
                </Row>
              </>
            ) : (
              <LottieLogo options={defaultOptions} />
            )}
          </CardBody>
        </Card>
      </div>
    </Container>
  );
}
